import { render, staticRenderFns } from "./settingPermissions2.vue?vue&type=template&id=886594f8&scoped=true&"
import script from "./settingPermissions2.vue?vue&type=script&lang=js&"
export * from "./settingPermissions2.vue?vue&type=script&lang=js&"
import style0 from "./settingPermissions2.vue?vue&type=style&index=0&id=886594f8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "886594f8",
  null
  
)

export default component.exports